import React from "react";

import { getEmojiClassName } from "../../utils/emojis";
import markdown from "../../utils/markdown";
import classNames from "classnames";
import TranslationIndicator from "components/shared/TranslationIndicator";

function markdownTextToHtml(text: string): TrustedHTML {
  let html: TrustedHTML;

  try {
    html = markdown.render(text);
  } catch (e) {
    console.log("Markdown error", e);
    html = `<span class="text-danger">${I18n.t(
      "js.chat.room.message.rendering_error",
    )}</span>`;
  }

  return html;
}

type MessageTextArgs = {
  text: string | null;
  isUpdated?: boolean;
  isDeleted?: boolean;
  translated?: boolean;
};
function MessageText({
  text,
  isUpdated = false,
  translated = false,
  isDeleted = false,
}: MessageTextArgs) {
  if (isDeleted || text === null)
    return (
      <div className="chat__message_text ">
        <span className="text-muted italic text-sm">
          {I18n.t("js.chat.room.message.deleted_message.text")}
        </span>
      </div>
    );

  const emoji = getEmojiClassName(text);

  return (
    <div
      className={classNames({
        chat__message_text: !isUpdated,
        "chat__message_text--edited": isUpdated,
      })}
    >
      <div
        className={emoji ? emoji : "inline prose prose-sm break-words"}
        dangerouslySetInnerHTML={{ __html: markdownTextToHtml(text) }}
      />
      {translated && (
        <TranslationIndicator
          style={{
            display: "block",
          }}
        />
      )}
    </div>
  );
}

export default React.memo(
  MessageText,
  (prevProps, nextProps) =>
    prevProps.text === nextProps.text &&
    prevProps.translated === nextProps.translated &&
    prevProps.isUpdated === nextProps.isUpdated,
);
